import { Component, ChangeDetectionStrategy } from "@angular/core";
import { GridBaseComponent } from "../grid-base/grid-base.component";
import { InputNumberComponent } from "../../../input-number/input-number.component";
import { ValidationRuleDirective } from "../../../../validation/validation-rule.directive";
import { FormsModule } from "@angular/forms";

@Component({
    selector: "rask-grid-input-number",
    template: `
        @if (rule) {
          <rask-input-number [raskRule]="rule" raskRuleDisplayType="Popover" [placeholder]="placeholder"
          class="cell grid" [(ngModel)]="value" [disabled]="readonly"></rask-input-number>
        }
        @if (!rule) {
          <rask-input-number [placeholder]="placeholder" class="cell" [(ngModel)]="value"
          [disabled]="readonly"></rask-input-number>
        }
        `,
    styleUrls: ["../grid-base/grid-base.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InputNumberComponent,
        ValidationRuleDirective,
        FormsModule
    ]
})
export class GridInputNumberComponent extends GridBaseComponent {
}
